var _style, _g, _path, _polygon, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmartOm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 197.3 85.4",
    style: {
      enableBackground: "new 0 0 197.3 85.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFDB00;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:#1C7975;}\r\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.1,46h-7.9c-2.6,0-4.8,0.8-6.4,2.5V39h-3.7v46.4h3.7v-2.9c0.3,0.3,0.5,0.6,0.8,0.9c1.3,1.5,3.2,2.2,5.6,2 h7.9c9,0.2,13.4-3.6,13.2-11.2V57.5C127.1,50,122.7,46.2,114.1,46z M123.9,74.7c0,6-3.3,8.9-9.8,8.7h-7.9c-2.5,0-4.7-0.9-6.4-2.7 V50.5c1.5-1.7,3.6-2.5,6.4-2.5h7.9c6.4,0.2,9.7,3.3,9.8,9.3V74.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.9,46h-7.6c-7.7,0-11.4,3.7-11.2,11h3.7c-0.2-5.8,2.2-8.8,7.3-9h7.8c5.8,0,8.7,3.1,8.7,9.3v5.6 c-1.6-1.7-3.8-2.5-6.4-2.5h-8.4c-8.6,0-12.8,3.8-12.7,11.5v2.2c-0.6,7.7,3.7,11.4,12.7,11.2h6.4c3.7,0.2,6.5-1,8.4-3.5v3.6h3.6 v-0.2l0-28.6C162.3,49.5,158.2,46,149.9,46z M150.3,83.4H148h-1.4h-2.7c-6.4,0.4-9.4-2.5-9-8.7v-3.1c-0.2-6.2,2.8-9.3,9-9.3h3h1.1 h4.5c1.9,0.2,3.6,0.8,5.1,1.7c0.4,0.3,0.7,0.7,1.1,1.1v1.5v1.1v5.1v3.4v0.8v0.3v2.3C156.4,82.1,153.6,83.4,150.3,83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.1,46h-1.8h-1.2h-1.8c-8.6,0.2-13,4-13.2,11.5v16.6c-0.2,7.7,4.2,11.4,13.2,11.2h1.8h1.2h1.8 c9,0.2,13.4-3.6,13.2-11.2V57.5C197.1,50,192.7,46.2,184.1,46z M193.9,74.7c0,6-3.3,8.9-9.8,8.7h-4.8c-6.6,0.2-9.8-2.7-9.8-8.7 V57.2c0.2-6,3.5-9.1,9.8-9.3h4.8c6.4,0.2,9.7,3.3,9.8,9.3V74.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 147.9173,
    y1: 165.5275,
    x2: 189.5208,
    y2: 165.5275,
    gradientTransform: "matrix(0.9968 7.803118e-02 -8.002755e-02 0.9719 -73.2887 -147.8211)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BD2C29"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3197,
    style: {
      stopColor: "#D27128"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7139,
    style: {
      stopColor: "#F5C123"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5C32A",
      stopOpacity: 0.314
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.6,0c0,0-2.4,17.4-13.1,24.7c0,0,2.6-8.7-0.9-16.6c0,0,2.9,8.4-11.5,17.2c-15.9,9.8-17.6,17.6-20.5,27.2 c0,0,9-19.2,21.8-20.8c0,0,1.2,3.3-2.8,7.2C77.6,38.8,103.3,33.6,104.6,0z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "82.5,39 67.4,79.2 51.2,39 46.9,39 65,85.4 67.5,85.4 76.3,85.4 93.7,39  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.9,39H0.1v46.4h11.2V67.7h24.6c7.3,0.2,11-3,11-9.6v-9.6C46.9,42.2,43.2,39,35.9,39z M35.7,52.2v1.4v2.6 c0,6-3.3,8.9-9.8,8.7H24h-2.3h-0.4h-1.5h-0.3h-0.1h-1.7c-2.5,0-4.7-0.9-6.4-2.7v-1.5v-1.1v-6v-1.4v-4.4V46v-1.2 c1.5-1.7,3.6-2.5,6.4-2.5h1.8h0.3h1.8H24h1.8c6.4,0.2,9.7,3.3,9.8,9.3V52.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartOm);
export default __webpack_public_path__ + "static/media/SmartOM.b23cff0f1caa7df18bfbb925a9d386a4.svg";
export { ForwardRef as ReactComponent };